<template>
  <div  @click="ChangeLayout()" class="cursor-pointer transition duration-500 hover:scale-105 flex gap-x-2 items-center justify-center">
    <v-icon name="eye" class="fill-current text-indigo-600 dark:text-indigo-400 w-8 h-8 ml-3 md:ml-0" />
    <p class="font-bold text-indigo-600 dark:text-indigo-400 font-mono tracking-widest uppercase hidden md:block">Yuxuan PANG</p>
  </div>
</template>

<script>
import { layouts } from "@/store";
import { mutations } from "@/store/mutationsNames";

export default {
  name: "TheLogo",
  data() {
    return {
      layouts: layouts,
    };
  },
  methods: {
    ChangeLayout() {
      if (this.$store.state.layout === layouts.landing)
      {
        this.$store.commit(mutations.SetLayout, layouts.centered);
      } 
      else
      {
        this.$store.commit(mutations.SetLayout, layouts.landing);
      }
    },
  },
};
</script>
